import script from "./MyRecords.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyRecords.vue?vue&type=script&setup=true&lang=ts"

import "./MyRecords.vue?vue&type=style&index=0&id=547942f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-547942f0"]])

export default __exports__